import {
  getEditorString,
  isRangeAcrossBlocks,
  isType,
  PlateEditor,
  someNode,
  Value,
} from '@udecode/plate-common';

import {
  ELEMENT_ANCHOR_LINK,
  ELEMENT_INTERLINK,
  ELEMENT_LINK,
} from '../../../plateTypes';
import {
  floatingLinkActions,
  floatingLinkSelectors,
} from '../hooks/floatingLinksStore';

/**
 * Trigger floating link.
 *
 * Do not trigger when:
 *
 * - Selection is across blocks
 * - Selection has more than one leaf node
 * - Lowest selection is not text
 * - Selection has a link node
 */
export const triggerFloatingLinkInsert = <V extends Value>(
  editor: PlateEditor<V>,
  {
    focused,
  }: {
    focused?: boolean;
  } = {},
): boolean | void => {
  if (floatingLinkSelectors.mode()) return;
  if (!focused) return;
  if (isRangeAcrossBlocks(editor, { at: editor.selection })) return;

  const hasLink = someNode(editor, {
    match: (node) =>
      isType(editor, node, [
        ELEMENT_LINK,
        ELEMENT_ANCHOR_LINK,
        ELEMENT_INTERLINK,
      ]),
  });

  if (hasLink) return;
  floatingLinkActions.text(getEditorString(editor, editor.selection));
  floatingLinkActions.show('insert', editor.id);

  return true;
};
